module.exports = __webpack_public_path__ + "img/IMG_1962_P_Wood_MockedUp.4b8bfe9b.jpg";